import {
  addZoneIdentityAccount,
  updateZoneIdentityAccount,
  deleteZoningAccount,
  enableDeactivateAccount,
  getZoneIdentityTable,
  setInstitutionDataRules
} from '../services/zoneIdentityManage';

export default {
  namespace: 'ZoneIdentityManage',
  state: {
    fromPage: '', // 来源 zoning 为租户，否则为运营侧
  },
  effects: {

    // 获取区划管理员账号表格数据
    * getZoneIdentityTable ({ payload }, { call }) {
      try {
        return yield call(getZoneIdentityTable, payload);
      } catch (e) {
      }
    },

    // --------------- 表格删除、停启用操作 ---------------

    // 删除区划管理员账号
    * deleteZoningAccount ({ payload }, { call }) {
      try {
        return yield call(deleteZoningAccount, payload);
      } catch (e) {
      }
    },

    // 停用启用账号
    * enableDeactivateAccount ({ payload }, { call }) {
      try {
        return yield call(enableDeactivateAccount, payload);
      } catch (e) {
      }
    },

    // --------------- 新增、编辑身份操作 ---------------

    // 新建管理员账号
    * addZoneIdentityAccount ({ payload }, { call }) {
      try {
        return yield call(addZoneIdentityAccount, payload);
      } catch (e) {
      }
    },

    // 更新管理员账号
    * updateZoneIdentityAccount ({ payload }, { call }) {
      try {
        return yield call(updateZoneIdentityAccount, payload);
      } catch (e) {
      }
    },

    // --------------- 设置岗位 ---------------

    // 设置区划管理员数据权限
    * setInstitutionDataRules ({ payload }, { call }) {
      try {
        return yield call(setInstitutionDataRules, payload);
      } catch (e) {
      }
    },
    
    // 设置页面来源
    * updateFromPage ({ payload }, { put }) {
      if (!payload) return;
      yield put({
        type: 'update',
        payload: {
          fromPage: payload,
        },
      });
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
